import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "convert-to-exam-quizz-block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("span", {
    class: "convert-to-exam-quizz-block__icon mdi mdi-certificate-outline small dark"
  }, null, -1)), _createElementVNode("a", {
    class: "convert-to-exam-quizz-block__link",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.isConfirmDialogVisible = true)
  }, _toDisplayString(_ctx.$t('chapter.assessment.convertToExam.linkLabel').toString()), 1)]), _createVNode(_component_confirm_dialog, {
    visible: _ctx.isConfirmDialogVisible,
    title: _ctx.$t('chapter.assessment.convertToExam.confirmDialog.title').toString(),
    message: _ctx.$t('chapter.assessment.convertToExam.confirmDialog.message').toString(),
    "close-on-outside-click": false,
    onOnConfirmed: _cache[1] || (_cache[1] = $event => _ctx.convertQuizzToExamQuizz()),
    onOnDialogClose: _cache[2] || (_cache[2] = $event => _ctx.toggleConfirmDialogToFalse()),
    onOnCanceled: _cache[3] || (_cache[3] = $event => _ctx.toggleConfirmDialogToFalse())
  }, null, 8, ["visible", "title", "message"])], 64);
}